import { render, staticRenderFns } from "./NewChannel.vue?vue&type=template&id=6b4fef2c&scoped=true&"
import script from "./NewChannel.vue?vue&type=script&lang=js&"
export * from "./NewChannel.vue?vue&type=script&lang=js&"
import style0 from "./NewChannel.vue?vue&type=style&index=0&id=6b4fef2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4fef2c",
  null
  
)

export default component.exports